import React, {Component} from 'react';
import {connect} from 'react-redux';
import {NavLink} from "react-router-dom";
import {bindActionCreators} from "redux";
import {toggleModal} from "../reducers/content";
import {Control, Form} from "react-redux-form";
import { login, logout, forgotPassword, forgotPasswordToken } from '../reducers/auth'

function mapStateToProps(state) {
	return {
		auth: state.auth,
		content: state.content,
		scoreboard: state.scoreboard
	};
}

class Logout extends React.Component {
	render(){
		return (
			<div className="logout">
				<button onClick={this.props.logout}>Logout</button>
			</div>
		)
	}
}

const mapDispatchToProps = dispatch => bindActionCreators({
	toggleModal,
	login,
	logout,
	forgotPassword,
	forgotPasswordToken
}, dispatch)

class Header extends Component {
	forgotPassword(){
		if(this.props.auth.password_reset_token){
			this.props.forgotPassword();
		}
		else {
			this.props.forgotPasswordToken();
		}
	}

	render() {
		return (
			<header className="header bg-color_gradient paddingLeft-120">
				<div className="row">
					<div className="col-8">
						<div className="header-menu_style">
							<div className="header-menu_block">
								<ul className="header__menu">
									<li>
										<NavLink exact to={'/'}>Home</NavLink>
									</li>

									<li className="">
										<button onClick={(e) => {e.preventDefault(); this.props.toggleModal('rules')}} className={"btn-link"}>Challenge Rules</button>
									</li>

									<li className="">
										<NavLink to={'/halloffame'}>Hall of Fame</NavLink>
									</li>

									{!this.props.auth.token &&
										<li className="">
											<NavLink to={'/example'}>Challenge Example</NavLink>
										</li>
									}

									<li>
										<button onClick={(e) => {e.preventDefault(); this.props.toggleModal('about')}} className={"btn-link"} >About Cynet</button>
									</li>
								</ul>
								<div className="mobile header__right-block justify-content-center flex-column">
									<p className="header__text">Brought to you by</p>
									<img src={require("../img/CYNET LOGO-white.svg")} alt="" />
								</div>
							</div>
						</div>
					</div>

					<div className="col-4">
						<div className="header__login d-flex justify-content-end align-items-start">
							{this.props.auth.token && <div className="profile-link">Hello {this.props.auth.user.FirstName + ' ' + this.props.auth.user.LastName} <Logout {...this.props} /></div>}

							{!this.props.auth.token && !this.props.content.showLoginModal && <button onClick={(e) => {e.preventDefault(); this.props.toggleModal('login')}} className="header__login__btn">Login</button>}

							{this.props.content.showLoginModal &&
								<div className="login-container form-style">
									<Form className={'login-form'} onSubmit={this.props.login} model={'auth'}>
										{this.props.auth.loginError && <p className={"error"}>{this.props.auth.loginError}</p>}

										<div className="position-relative input-effect">
											<Control.text
												className={!!this.props.auth.user.email_address ? 'effect has-content' : 'effect'}
												model={'.user.email_address'} type="text"/>
											<label>Email</label>
										</div>

										<div className="position-relative input-effect">
											<Control.text
												className={!!this.props.auth.user.password ? 'effect has-content' : 'effect'}
												model={'.user.password'} type="password"/>
											<label>Password</label>
										</div>

										<button onClick={(e) => {e.preventDefault(); this.props.toggleModal('login'); this.props.toggleModal('password')}} className="forgot-password">Forgot your password?</button>

										<div className="login-buttons">
											<button onClick={(e) => {e.preventDefault(); this.props.toggleModal('login')}} className={'header__login__btn clear'}>Cancel</button>

											<button className={'header__login__btn'}>Login</button>
										</div>
									</Form>
								</div>
							}

							{this.props.content.showPasswordModal &&
								<div className="login-container form-style">
									<Form className={'login-form'} onSubmit={() => this.forgotPassword()} model={'auth'}>
										{this.props.auth.passwordResetError && <p className={"error"}>{this.props.auth.passwordResetError}</p>}

										{!this.props.content.showPasswordResetToken &&
											<div className="position-relative input-effect">
												<Control.text
													className={!!this.props.auth.user.email_address ? 'effect has-content' : 'effect'}
													model={'.user.email_address'} type="text"/>
												<label>Email</label>
											</div>
										}

										{this.props.content.showPasswordResetToken &&
											<React.Fragment>
												<div className="position-relative input-effect">
													<Control.text
														className={!!this.props.auth.user.password ? 'effect has-content' : 'effect'}
														model={'.user.password'} type="password"/>
													<label>New Password</label>
												</div>

												<div className="position-relative input-effect">
													<Control.text
														className={!!this.props.auth.password_reset_token ? 'effect has-content' : 'effect'}
														model={'.password_reset_token'} type="text"/>
													<label>Password Reset Key</label>
												</div>
											</React.Fragment>
										}

										<div className="login-buttons">
											<button onClick={(e) => {e.preventDefault(); this.props.toggleModal('password')}} className={'header__login__btn clear'}>Cancel</button>

											<button className={'header__login__btn'}>Reset</button>
										</div>
									</Form>
								</div>
							}

							<div className="header__right-block d-flex justify-content-center flex-column">
								<div className="mob-menu" />

								<p className="header__text">Brought to you by</p>
								<a target={'_blank'} rel="noopener noreferrer" href="https://www.cynet.com/partners/free-incident-response/?utm_source=irc">
									<img src={require("../img/CYNET LOGO-white.svg")} alt="" />
								</a>
							</div>
						</div>
					</div>
				</div>
			</header>
		);
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Header);